<p-dialog [header]="'notesDialog.contactLog' | transloco: { name: connectGallery?.Name }" [(visible)]="notesDialogVisible" [modal]="true"
  [style]="{ 'width': '530px', 'max-height': '80vh' }" (onHide)="closeNotesDialog()">
  <form class="form-horizontal mt-3 px-3">
    <div class="text-muted small mb-2">
      <i class="fa fa-info-circle me-1"></i> {{ 'notesDialog.notesAbout' | transloco: { name: connectGallery?.Name } }}
    </div>
    <div class="form-group mb-3">
      <div class="panel-container">
        <div class="panel-body position-relative">
          <textarea id="NewNotes" [(ngModel)]="newNoteText" pInputTextarea rows="3" name="NewNotes"
            [placeholder]="'notesDialog.typeYourNote' | transloco" class="form-control">
          </textarea>
          <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog()"
            style="top: 50%; right: 0.5rem; transform: translateY(-50%);">
            (😍)
          </div>
          <button pButton type="button" [disabled]="!newNoteText" class="p-button-outlined w-100 mt-2" [label]="'notesDialog.addNote' | transloco"
            (click)="saveNotes()">
          </button>
        </div>
      </div>
    </div>
    @if (notes.length > 0) {
      <p-panel [header]="'notesDialog.history' | transloco" [toggleable]="true" [style]="{ 'max-height': '400px', 'overflow-y': 'auto' }"
        >
        <ul class="px-2" style="list-style: none;">
          @for (note of notes; track note) {
            <li class="border-bottom pb-2">
              <span class="small fw-semibold text-muted">{{ note.CreatedDate | date: 'dd/MM/yyyy hh:mm:ss a' }}</span> -
              {{ note.Comments }}
            </li>
          }
        </ul>
      </p-panel>
    }
  </form>
</p-dialog>

<!-- Emoji-Dialog -->
@if (displayEmojiDialog) {
  <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
  (emojiClick)="addEmoji($event)"></app-emoji-list>
}